import React, { useState, useEffect } from "react";
import {
  AddIcon,
  BorderColorIcon,
  CreateNewFolderIcon,
  FilterAltOutlinedIcon,
} from "../../components/icons/Icons";
import { ProductImage } from "../../images/Images";
import axiosInstance from "../../axiosInstance";
import SearchComponent from "../../components/search/SearchComp";

interface OrderItem {
  id: string;
  name: string;
  description: string;
  quantity: number;
  price: number;
  line_total: number;
  product_id: {
    id: string;
    name: string;
    image: string;
    amount: number;
    unit: string;
    description: string;
    stock_count: number;
    tags: string;
  };
}

interface Order {
  id: string;
  order_code: string;
  status: string;
  amount: number;
  createdAt: string;
  is_paid: boolean;
  order_items: OrderItem[];
  customer: {
    id: string;
    full_name: string;
    email: string;
    phone_number: string;
    avatar: string;
  };
}

const LogTable: React.FC = () => {
  const [orders, setOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Get customer id from query string
  const searchParams = new URLSearchParams(window.location.search);
  const customerId = searchParams.get("id") || "";

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axiosInstance.get(`/customers/${customerId}`);
        setOrders(response.data.orders || []);
      } catch (err: any) {
        setError(err?.response?.data?.message || "Failed to fetch orders");
      } finally {
        setLoading(false);
      }
    };
    if (customerId) {
      fetchOrders();
    }
  }, [customerId]);

  const [isFilterModalOpen, setFilterModalOpen] = useState(false);
  const [isEditModalOpen, setEditModalOpen] = useState(false);

  const handleFilter = (filters: any) => {
    console.log("Filters Applied:", filters);
  };

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState<"all" | number>(10); // Default entries per page

  // Calculate pagination indexes
  const indexOfLastOrder =
    entriesPerPage === "all"
      ? orders.length
      : currentPage * Number(entriesPerPage);
  const indexOfFirstOrder =
    entriesPerPage === "all" ? 0 : indexOfLastOrder - Number(entriesPerPage);
  const currentOrders =
    entriesPerPage === "all"
      ? orders
      : orders.slice(indexOfFirstOrder, indexOfLastOrder);

  // Total pages
  const totalPages =
    entriesPerPage === "all"
      ? 1
      : Math.ceil(orders.length / Number(entriesPerPage));

  // Handle page change
  const handlePageChange = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Handle entries per page change
  const handleEntriesChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setEntriesPerPage(
      event.target.value === "all" ? "all" : Number(event.target.value)
    );
    setCurrentPage(1); // Reset to the first page
  };

  const handleSearch = (query: string) => {
    console.log("Search query:", query);
  };

  return (
    <div className="orders-table">
      {loading ? (
        <div style={{textAlign : "center"}}>Loading orders...</div>
      ) : error ? (
        <div style={{ color: "red", textAlign : "center" }}>{error}</div>
      ) : (
        <>
          <table>
            <tbody>
              {currentOrders.map((order, index) => (
                <tr key={order.id}>
                  <div className="stock_product_img customer">
                    {/* <img
                      src={order.order_items[0]?.product_id?.image || ProductImage}
                      alt="product img"
                      style={{ width: 40, height: 40, objectFit: "cover" }}
                    /> */}
                    <td>{order.order_items[0]?.product_id?.name || "-"}</td>
                  </div>
                  <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                  <td>{order.order_code}</td>
                  <td style={{ fontWeight: 800 }}>${order.amount}</td>
                  <td>
                    <button
                      className="edit-button"
                      style={{
                        color:
                          order.status === "completed"
                            ? "#43EB34"
                            : order.status === "pending"
                            ? "#DDBA00"
                            : "#FF0000",
                        textTransform: "capitalize",
                      }}
                    >
                      {order.status}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Entries dropdown and showing entries */}
          <div className="entries-control">
            <label>
              View
              <select
                className="entries-select"
                value={entriesPerPage}
                onChange={handleEntriesChange}
              >
                <option value="2">2</option>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="all">All</option>
              </select>
              Per Page
            </label>
            <div className="right__pagination">
              <p>
                Showing {indexOfFirstOrder + 1} to {Math.min(indexOfLastOrder, orders.length)} of {orders.length} entries
              </p>
              {entriesPerPage !== "all" && (
                <div className="pagination">
                  <button
                    className="pagination__button"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>
                  {[...Array(totalPages)].map((_, pageIndex) => (
                    <button
                      key={pageIndex}
                      className={`pagination__button ${currentPage === pageIndex + 1 ? "active" : ""}`}
                      onClick={() => handlePageChange(pageIndex + 1)}
                    >
                      {pageIndex + 1}
                    </button>
                  ))}
                  <button
                    className="pagination__button"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LogTable;
